Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.getSubscriptionAPiEndPoint =
  "customisable_user_subscriptions/subscriptions";
exports.getSubscriptionAPiMethod = "GET";
exports.subscriptionApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "customisableusersubscriptions";
exports.labelBodyText = "customisableusersubscriptions Body";

exports.activePlanApiEndpoint = "bx_block_order_management/sub_scription_orders/user_current_plan"
exports.subscriptionPlanApiEndpoint = "bx_block_custom_user_subs/subscriptions"
exports.updateSubscriptionPlanApiEndpoint = "bx_block_order_management/sub_scription_orders"
exports.TOKEN = "token"
exports.httpGetMethod = "GET"
exports.httpPostMethod = "POST"

exports.PLAN_DETAILS = {
  "Free": {
    duration: "for 1 year",
    shortDescription: "Ideal for New Users Exploring the Platform.",
    description: "Perfect for users who are new to the platform and want to explore its features without any commitment. Get started with full access to most of the features at no cost.",
    features: [
      { text: "Access to All Features", available: false },
      { text: "Advanced Search & Filtering", available: true },
      { text: "Portfolio Showcase", available: true },
      { text: "Detailed User Profile", available: true },
      { text: "Unlimited Messaging", available: true },
      { text: "Priority Support", available: false },
      { text: "Exclusive Content", available: false },
      { text: "Analytics & Insights", available: false },
    ]
  },
  "Monthly": {
    duration: "per month",
    shortDescription: "Great for Flexible and Short-Term Users.",
    description: "Ideal for users who are committed to using the platform long-term and want to enjoy significant cost savings with a discounted yearly rate. Access exclusive annual benefits.",
    features: [
      { text: "Access to All Features", available: true },
      { text: "Advanced Search & Filtering", available: true },
      { text: "Portfolio Showcase", available: true },
      { text: "Detailed User Profile", available: true },
      { text: "Unlimited Messaging", available: true },
      { text: "Priority Support (Coming soon)", available: true },
      { text: "Exclusive Content (Coming soon)", available: true },
      { text: "Analytics & Insights (Coming soon)", available: true },
    ],
  },
  "Yearly": {
    duration: "per year",
    shortDescription: "Best for Committed Users Seeking Maximum Savings.",
    description: "Ideal for users who are committed to using the platform long-term and want to enjoy significant cost savings with a discounted yearly rate. Access exclusive annual benefits.",
    features: [
      { text: "Access to All Features", available: true },
      { text: "Advanced Search & Filtering", available: true },
      { text: "Portfolio Showcase", available: true },
      { text: "Detailed User Profile", available: true },
      { text: "Unlimited Messaging", available: true },
      { text: "Priority Support (Coming soon)", available: true },
      { text: "Exclusive Content (Coming soon)", available: true },
      { text: "Analytics & Insights (Coming soon)", available: true },
    ]
  }
}

exports.btnExampleTitle = "CLICK ME";
exports.confirmText = "Confirm"
exports.congratulationsText = "Congratulations!"
exports.subscriptions = "Subscriptions";
exports.upgradePlanText = "Upgrade Plan"
exports.paymentFailedText = "Payment failed!"
exports.upgradePlanDescriptionText = "Are you sure you want to upgrade your plan?"
exports.chooseYourPlanText = "Choose Your Right Plan!"
exports.selectPlanDescriptionText = "Select from best plans, ensuring a perfect match. Need more or less?\nCustomize your subscription for a seamless fit!"
exports.chooseSubscription = "Choose from the list of subscriptions";
exports.subscriptionDetailsScreenName = "SubscriptionDetails";
exports.goldCoinImageUrl =
  "https://akm-img-a-in.tosshub.com/sites/btmt/images/stories/goldcoin_660_102616075839.jpg";
exports.currencySymbol = "₹";
exports.zero = "0";
exports.subscribed = "Subscribed";
exports.subscribe = "Subscribe";
exports.freeText = "Free"
exports.getPlanText = "Get Plan"
exports.yourCurrentPlanText = "Your Current Plan"
exports.subscriptionDetails = "Subscription Details";
exports.confirmSubscription = "Confirm Subscription";
exports.noSubscriptionAvailable = "No subscriptions available";
// Customizable Area End
